import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { ImprimirMinutaGrilla } from './components/ImprimirMinutaGrilla';

export default function ImprimirMinuta() {
  return (
    <>
      <MainContent
        titulo='Imprimir Minuta'
        component={<ImprimirMinutaGrilla />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}